<div class="heading">
  Tell us about yourself
</div>

<form [formGroup]="formGroup">
  <div class="form-field" id="gender" style="margin-top: 20px;">
    <p class="form-field-heading">Gender</p>
    <mat-button-toggle-group name="gender" formControlName="gender">
      <mat-button-toggle *ngFor="let option of GenderOptions"
                         value="{{ option.value }}">{{ option.displayName }}
      </mat-button-toggle>
    </mat-button-toggle-group>
    <mat-error class="small-text"
               *ngIf="formGroup.controls.gender.touched">{{ getErrorMessage(formGroup.controls.gender) }}
    </mat-error>
  </div>

  <div class="form-field">
    <p class="form-field-heading">Date of birth</p>
    <mat-form-field id="date-picker">
      <input matInput [matDatepicker]="picker"
             [max]="maximumDateOfBirthAllowed()"
             [min]="minimumDateOfBirthAllowed()"
             formControlName="dateOfBirth"
             placeholder="DD/MM/YYYY">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error>{{ getErrorMessage(formGroup.controls.dateOfBirth) }}</mat-error>
    </mat-form-field>
  </div>

  <div class="row form-field">
    <p class="form-field-heading col-xs-12">Educational qualification</p>
    <mat-form-field class="col-xs-12">
      <mat-select placeholder="Select education qualification" formControlName="educationalQualification">
        <mat-option *ngFor="let option of QualificationOptions" [value]="option.value">
          {{ option.value }}
        </mat-option>
      </mat-select>
      <mat-error>{{ getErrorMessage(formGroup.controls.educationalQualification) }}</mat-error>
    </mat-form-field>
  </div>

  <div class="form-field" id="marital-status">
    <p class="form-field-heading">Marital status</p>
    <mat-button-toggle-group name="maritalStatus" formControlName="maritalStatus">
      <mat-button-toggle *ngFor="let option of MaritalStatusOptions"
                         value="{{ option.value }}">{{ option.displayName }}
      </mat-button-toggle>
    </mat-button-toggle-group>
    <mat-error class="small-text"
               *ngIf="formGroup.controls.maritalStatus.touched">{{ getErrorMessage(formGroup.controls.maritalStatus) }}
    </mat-error>

  </div>

  <div class="row form-field">
    <div class="col-xs-12">
      <p class="form-field-heading">Current Residential Address</p>
      <p class="form-field-sub-heading">Loan documentation & field verification will be done at this address</p>
      <div class="row">
        <mat-form-field class="col-xs-12">
          <input matInput type="text" formControlName="addressStreet"
                 placeholder="You will need an address proof for this address">
          <mat-error>{{ getErrorMessage(formGroup.controls.addressStreet) }}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <p class="col-xs-12 form-field-sub-heading pt-2">Select a city (finzy currently offers loans only in the below mentioned cities)</p>
    <mat-form-field class="col-md-4 col-xs-12 drop-down">
      <input type="text" matInput formControlName="addressCity" placeholder="Please enter city name" [matAutocomplete]="city" (ngModelChange)="getCityName()" (focusout)="validateCity($event)">
      <mat-autocomplete #city="matAutocomplete">
        <mat-option *ngFor="let city of filteredCities | async"
                    [value]="city">
            {{ city }}
        </mat-option>
    </mat-autocomplete>
      <mat-error>{{ getErrorMessage(formGroup.controls.addressCity) }}</mat-error>
    </mat-form-field>
    <mat-form-field class="col-md-4 col-xs-12">
      <mat-select placeholder="Select state" formControlName="addressState">
        <mat-option *ngFor="let state of states" [value]="state">
          {{ state }}
        </mat-option>
      </mat-select>
      <mat-error>{{ getErrorMessage(formGroup.controls.addressState) }}</mat-error>
    </mat-form-field>
    <mat-form-field class="col-md-4 col-xs-12">
      <input matInput type="text" placeholder="Pincode" formControlName="addressPincode">
      <mat-error>{{ getErrorMessage(formGroup.controls.addressPincode) }}</mat-error>
    </mat-form-field>
  </div>

  <div class="row ">
    <div class="col-xs-6">
      <button mat-stroked-button class="button-back primary" type="button" (click)="previousPage()">
        <i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;BACK
      </button>
    </div>
    <div class="col-xs-6">
      <div class="pull-right">
        <app-forward-button class="button-forward" (click)="onSubmit(formGroup)" [isLoading]="loaderStatus.isLoading">
          NEXT
        </app-forward-button>
      </div>
    </div>
  </div>
</form>
